// React
import { createContext } from 'react';

export const SalesChannelContext = createContext({});